// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Css3OutlinedSvg from "@fishx/icons-svg/es/asn/Css3Outlined";
import FishxIcon from '../components/FishxIcon';

var Css3Outlined = function Css3Outlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: Css3OutlinedSvg
  }));
};

Css3Outlined.displayName = 'Css3Outlined';
export default React.forwardRef(Css3Outlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/Css3Outlined.js
// module id = 2351
// module chunks = 0